export default __webpack_public_path__ + "static/media/cowboy-faceoff.65629b89.png";